document.documentElement.classList.remove('no-js');

document.querySelectorAll('[data-hero-video-sequence]').forEach((sequence) => {
  const videos = Array.from(sequence.querySelectorAll('video'));
  if (!videos.length) return;

  const duration = Number(sequence.dataset.videoDuration || 5) * 1000;
  let activeIndex = 0;
  let timer;

  const showVideo = (index) => {
    window.clearTimeout(timer);
    const nextIndex = index % videos.length;
    videos.forEach((video, videoIndex) => {
      const active = videoIndex === nextIndex;
      video.classList.toggle('is-active', active);
      if (active) {
        if (video.preload === 'none') {
          video.preload = 'auto';
          video.load();
        }
        video.currentTime = 0;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
    activeIndex = nextIndex;
    timer = window.setTimeout(() => showVideo(activeIndex + 1), duration);
  };

  showVideo(0);
});

const setMobileMenu = (open) => {
  const menu = document.querySelector('[data-mobile-menu]');
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  if (!menu || !toggle) return;
  menu.classList.toggle('is-open', open);
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
};

const setActiveGalleryImage = (section, { src, alt, mediaId }) => {
  const main = section.querySelector('[data-gallery-main]');
  if (!main || !src) return;

  main.src = src;
  main.removeAttribute('srcset');
  if (alt) main.alt = alt;
  if (mediaId) main.dataset.mediaId = mediaId;

  section.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    const active = mediaId ? button.dataset.mediaId === String(mediaId) : button.dataset.fullSrc === src;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
};

const updateVariantAvailability = (form, variants, selected) => {
  form.querySelectorAll('[data-option-label]').forEach((label) => {
    const position = Number(label.dataset.optionPosition) - 1;
    const value = label.dataset.optionValue;
    const available = variants.some((variant) => {
      return variant.available && variant.options.every((optionValue, index) => {
        return index === position ? optionValue === value : !selected[index] || optionValue === selected[index];
      });
    });
    label.classList.toggle('is-unavailable', !available);
  });
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (toggle) {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    setMobileMenu(open);
  }

  const galleryButton = event.target.closest('[data-gallery-thumb]');
  if (galleryButton) {
    const section = galleryButton.closest('[data-product-section]');
    const image = galleryButton.querySelector('img');
    if (section && image) {
      setActiveGalleryImage(section, {
        src: galleryButton.dataset.fullSrc,
        alt: image.alt || '',
        mediaId: galleryButton.dataset.mediaId
      });
    }
  }

  const quantityButton = event.target.closest('[data-quantity-button]');
  if (quantityButton) {
    const input = quantityButton.parentElement.querySelector('input');
    const delta = quantityButton.dataset.quantityButton === 'plus' ? 1 : -1;
    const min = input && input.min !== '' ? Number(input.min) : 1;
    const next = Math.max(min, Number(input.value || min || 0) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') setMobileMenu(false);
});

document.addEventListener('change', (event) => {
  const optionInput = event.target.closest('[data-product-option]');
  if (!optionInput) return;

  const form = optionInput.closest('form');
  const section = form.closest('[data-product-section]');
  const variantInput = form.querySelector('[name="id"]');
  const variants = JSON.parse(form.querySelector('[data-variants-json]').textContent);
  const selected = Array.from(form.querySelectorAll('[data-product-option]:checked')).map((input) => input.value);
  const variant = variants.find((candidate) => {
    return candidate.options.every((value, index) => value === selected[index]);
  });

  const submitButtons = form.querySelectorAll('[data-product-submit]');
  const price = section.querySelector('[data-product-price]');
  const currentPrice = price && price.querySelector('[data-price-current]');
  const comparePrice = price && price.querySelector('[data-price-compare]');
  const status = section.querySelector('[data-variant-status]');

  if (variantInput && variant) variantInput.value = variant.id;
  updateVariantAvailability(form, variants, selected);

  if (variant && currentPrice) currentPrice.textContent = variant.price;
  if (comparePrice) {
    comparePrice.textContent = variant && variant.compare_at_price ? variant.compare_at_price : '';
    comparePrice.classList.toggle('is-hidden', !variant || !variant.compare_at_price);
  }
  if (status) {
    let statusText;
    if (!variant) {
      statusText = form.dataset.unavailableLabel || 'Mevcut değil';
    } else if (!variant.available) {
      statusText = form.dataset.soldOutLabel || 'Tükendi';
    } else if (variant.inventory !== null && variant.inventory > 0 && variant.inventory <= 5) {
      statusText = 'Son ' + variant.inventory + ' adet · hemen gönderime hazır';
    } else {
      statusText = form.dataset.inStockLabel || 'Stokta var';
    }
    status.textContent = statusText;
    status.classList.toggle('is-sold-out', !variant || !variant.available);
    status.classList.toggle('is-low-stock', !!(variant && variant.available && variant.inventory !== null && variant.inventory > 0 && variant.inventory <= 5));
  }
  if (variant && variant.media_src && section) {
    setActiveGalleryImage(section, {
      src: variant.media_src,
      alt: variant.media_alt || '',
      mediaId: variant.media_id
    });
  }
  submitButtons.forEach((submit) => {
    submit.disabled = !variant || !variant.available;
    submit.textContent = !variant
      ? form.dataset.unavailableLabel || 'Mevcut değil'
      : variant.available
        ? form.dataset.addLabel || 'Sepete Ekle'
        : form.dataset.soldOutLabel || 'Tükendi';
  });
});

document.querySelectorAll('form [data-variants-json]').forEach((script) => {
  const form = script.closest('form');
  if (!form) return;
  const variants = JSON.parse(script.textContent);
  const selected = Array.from(form.querySelectorAll('[data-product-option]:checked')).map((input) => input.value);
  updateVariantAvailability(form, variants, selected);
});

(() => {
  const STORAGE_KEY = 'dogal_cookie_consent';
  const VERSION = '1.0';
  const banner = document.querySelector('[data-cookie-banner]');
  if (!banner) return;

  const settings = banner.querySelector('[data-cookie-settings]');
  const customize = banner.querySelector('[data-cookie-customize]');
  const reject = banner.querySelector('[data-cookie-reject]');
  const accept = banner.querySelector('[data-cookie-accept]');
  const save = banner.querySelector('[data-cookie-save]');

  const getConsent = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      return parsed && parsed.version === VERSION ? parsed : null;
    } catch {
      return null;
    }
  };

  const emitConsent = (consent) => {
    window.dispatchEvent(new CustomEvent('dogal:cookie-consent', { detail: consent }));
  };

  const persistConsent = (prefs) => {
    const consent = {
      necessary: true,
      analytics: Boolean(prefs.analytics),
      marketing: Boolean(prefs.marketing),
      preferences: Boolean(prefs.preferences),
      timestamp: Date.now(),
      version: VERSION
    };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    banner.hidden = true;
    emitConsent(consent);
  };

  const syncChoices = (consent) => {
    banner.querySelectorAll('[data-cookie-choice]').forEach((input) => {
      input.checked = Boolean(consent && consent[input.dataset.cookieChoice]);
    });
  };

  const openPreferences = () => {
    syncChoices(getConsent());
    settings.hidden = false;
    customize.hidden = true;
    reject.hidden = true;
    accept.hidden = true;
    save.hidden = false;
    banner.hidden = false;
  };

  customize && customize.addEventListener('click', openPreferences);
  reject && reject.addEventListener('click', () => persistConsent({}));
  accept && accept.addEventListener('click', () => persistConsent({ analytics: true, marketing: true, preferences: true }));
  save && save.addEventListener('click', () => {
    const prefs = {};
    banner.querySelectorAll('[data-cookie-choice]').forEach((input) => {
      prefs[input.dataset.cookieChoice] = input.checked;
    });
    persistConsent(prefs);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cookie-preferences]')) {
      openPreferences();
    }
  });

  window.addEventListener('cookie-consent-reset', openPreferences);

  const existing = getConsent();
  if (existing) {
    emitConsent(existing);
  } else {
    window.setTimeout(() => {
      banner.hidden = false;
    }, 600);
  }
})();

// --- Scroll reveal (mikro animasyon) ---
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = document.querySelectorAll('.product-card, .lookbook-shot, [data-reveal]');
  if (!els.length) return;
  els.forEach(function (el, i) {
    el.classList.add('reveal-init');
    el.style.transitionDelay = Math.min((i % 4) * 60, 180) + 'ms';
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function (el) { io.observe(el); });
})();

// --- Ürün formu: AJAX sepete ekleme + drawer + buton animasyonu ---
(function () {
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (typeof CartDrawer === 'undefined') return; // drawer yoksa normal akış
      e.preventDefault();
      var btn = form.querySelector('[data-product-submit]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Ekleniyor…'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          if (btn) {
            btn.textContent = 'Eklendi ✓';
            btn.classList.add('btn-added');
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
              btn.classList.remove('btn-added');
            }, 1200);
          }
          CartDrawer.refresh();
          CartDrawer.open();
        })
        .catch(function () {
          if (btn) { btn.textContent = original; btn.disabled = false; }
          form.submit(); // hata olursa normal akışa düş
        });
    });
  });
})();
